export default __webpack_public_path__ + "img/graphic-layer.png";